import { createTheme, rem } from "@mantine/core"

export const theme = createTheme({
    colors: {
        // dark: ["#f8f9fa", "#e9ecef", "#dee2e6", "#ced4da", "#adb5bd", "#6c757d", "#495057", "#343a40", "#212529", "#0b0b0b"],
        // gray: ["#f9f9f9", "#f4f4f5", "#e4e4e7", "#d4d4d8", "#a1a1aa", "#71717a", "#52525b", "#3f3f46", "#27272a", "#18181b"],
        // light: ["#ffffff", "#fcfcfc", "#f9f9f9", "#f5f5f5", "#f0f0f0", "#e5e5e5", "#dcdcdc", "#c4c4c4", "#adadad", "#999999"],
        off: ["#f8f8f1", "#eeefe4", "#dcdec3", "#c8cd9f", "#b7be80", "#adb46d", "#a8b061", "#929a51", "#828946", "#6f7637"],
    },
    components: {
        Button: {
            // styles: (theme) => ({
            //     root: {
            //         borderRadius: theme.radius.md,
            //         fontWeight: 500,
            //     },
            // }),
        },
        Card: {
            // styles: (theme) => ({
            //     root: {
            //         backgroundColor: "#fff",
            //         border: `1px solid ${theme.colors.gray[2]}`,
            //         borderRadius: theme.radius.md,
            //         boxShadow: "none",
            //     },
            // }),
        },
    },
    defaultRadius: "md",
    // fontFamily: "Inter, sans-serif",
    headings: {
        fontFamily: "Inter, sans-serif",
        sizes: {
            h1: { fontSize: "2.25rem", fontWeight: "700" },
            h2: { fontSize: "1.875rem", fontWeight: "600" },
            h3: { fontSize: "1.5rem", fontWeight: "600" },
        },
    },
    primaryColor: "dark",
    spacing: {
        lg: rem(24),
        md: rem(16),
        sm: rem(12),
        xl: rem(32),
        xs: rem(8),
    },
})
